import { head } from 'ramda';
import React, { FC, useMemo, useRef, useEffect } from 'react';
import { Kampos, effects } from '@wix/wix-kampos';
import { useVideoPreviews } from '../../../../utils/media-manager-sdk/hooks';
import expandedViewStyles from '../../ExpandedView.scss';
import { IVideoAlphaOuter } from '../ItemDemonstration.types';
import classnames from 'classnames';

const MAX_DEMO_HEIGHT = parseInt(expandedViewStyles.maxDemonstrationHeigth, 10);

export const VideoAlpha: FC<IVideoAlphaOuter> = ({ item, className, wrapperDimension, saveRef }) => {
  const maxHeight = wrapperDimension ? Math.min(MAX_DEMO_HEIGHT, wrapperDimension.height) : MAX_DEMO_HEIGHT;
  const videoHeight = Math.min(item.height, maxHeight * 2) || 0;
  const videoWidth = Math.round((item.width * videoHeight) / item.height) || 0;
  const divMaxHeight = Math.round(videoHeight / 2) - 1 || 0;

  const style = useMemo(() => ({ maxHeight: divMaxHeight, overflow: 'hidden' }), [divMaxHeight]);

  const videoStyle = { display: 'none' };
  const alpha = effects.transparentVideo();
  const canvasElement = useRef<HTMLCanvasElement>();
  const videoElement = useRef<HTMLVideoElement>();
  const canvasStyle = useMemo(() => ({ maxHeight: divMaxHeight }), [divMaxHeight]);

  useEffect(() => {
    const media = videoElement.current;
    const target = canvasElement.current;
    const player = new Kampos({ target, effects: [alpha] });

    const playHandler = () => {
      if (player.gl && player.gl.canvas) {
        const height = media.videoHeight / 2;
        const width = media.videoWidth;

        player.setSource({ media, width, height });

        player.play(() => {
          return player.media && player.media.readyState >= player.media.HAVE_CURRENT_DATA;
        });
      }
    };

    media.addEventListener('play', playHandler);

    return () => {
      player.destroy();
    };
  }, []);

  return (
    <div
      className={classnames(expandedViewStyles.checkersBackground, className)}
      data-hook="expanded-view-videoalpha-demonstration"
      ref={saveRef}
    >
      <div className={expandedViewStyles.transparentVideoContainer} style={style}>
        <video
          ref={videoElement}
          src={head(useVideoPreviews(item))}
          loop
          controls={false}
          autoPlay
          width={wrapperDimension ? Math.min(wrapperDimension.width, videoWidth) : videoWidth}
          height={videoHeight}
          style={videoStyle}
          crossOrigin="anonymous"
        />
        <canvas ref={canvasElement} style={canvasStyle} />
      </div>
    </div>
  );
};
